import type { BadgeColors } from "@/components/base/badges/badge-types";

type ProtocolBadgeColor = "protocol-uniswap-v3" | "protocol-uniswap-v4";

const PROTOCOL_BADGE_COLOR_MAP: Record<string, ProtocolBadgeColor> = {
	v3: "protocol-uniswap-v3",
	v4: "protocol-uniswap-v4",
};

export function getProtocolBadgeColor(protocol: string): BadgeColors {
	return PROTOCOL_BADGE_COLOR_MAP[protocol.trim().toLowerCase()] ?? "gray";
}

export function formatProtocolBadgeLabel(protocol: string, options?: { withPrefix?: boolean }) {
	const normalized = protocol.trim().toLowerCase();
	const versionLabel = normalized.startsWith("v")
		? normalized.toUpperCase()
		: `V${normalized.toUpperCase()}`;

	return options?.withPrefix ? `Uniswap ${versionLabel}` : versionLabel;
}
